module.exports = __webpack_public_path__ + "img/icono.2a92d44a.png";